// extracted by mini-css-extract-plugin
export var thumbnail = "thumbnail-module--thumbnail--ryQb2";
export var thumbnailTitle = "thumbnail-module--thumbnail-title--Su1Jq";
export var thumbnailSubtitle = "thumbnail-module--thumbnail-subtitle--hAati";
export var thumbnailMedia = "thumbnail-module--thumbnail-media--2b2wX";
export var thumbnailOverlayContainer = "thumbnail-module--thumbnail-overlay-container--oCOXS";
export var thumbnailOverlay = "thumbnail-module--thumbnail-overlay--A+Bv-";